import { useState, useEffect } from 'react';
import { ACTIVE_SESSION_KEY_PREFIX } from './constants';

/**
 * Persists the active sessionId to localStorage per domain so tab switches
 * don't lose conversation context. Restores on mount if a prior session exists.
 */
export function useSessionPersistence(domainIdentifier: string) {
  const [sessionId, setSessionId] = useState<string | null>(() => {
    try {
      return localStorage.getItem(`${ACTIVE_SESSION_KEY_PREFIX}:${domainIdentifier}`) || null;
    } catch { return null; }
  });

  useEffect(() => {
    const key = `${ACTIVE_SESSION_KEY_PREFIX}:${domainIdentifier}`;
    if (sessionId) {
      try { localStorage.setItem(key, sessionId); } catch {}
    } else {
      try { localStorage.removeItem(key); } catch {}
    }
  }, [sessionId, domainIdentifier]);

  return [sessionId, setSessionId] as const;
}
